import { key } from 'piqure';
import type { RulesRepository } from '@/rules-management/domain/RulesRepository.ts';

export const RULES_REPOSITORY = key<RulesRepository>('RulesRepository');
